export const formCustomersDataTask = ({
  customersData,
  selectedSegments,
  customerGroups,
  isEnableSendEmail,
  storeViewCode
}) => {
  if (!customersData?.length) {
    return [];
  }

  const gender = {
    male: 1,
    female: 2
  };

  const selectedSegmentsIds = selectedSegments.map((s) => s.value);
  const isCustomer3 = storeViewCode === 'customer3';
  const groupIndex = isCustomer3 ? 7 : 6;

  const tasks = customersData.map((customerRow) => {
    const groupCode = customerRow[groupIndex]?.trim();
    const group = customerGroups.find((g) => g.code.toLowerCase() === groupCode?.toLowerCase());

    const task = {
      body: {
        customer: {
          dob: customerRow[5].trim() || '01/01/1972',
          email: customerRow[2].trim(),
          firstname: customerRow[0].trim(),
          lastname: customerRow[1].trim(),
          gender: customerRow[4]?.length ? gender[customerRow[4]?.toLowerCase()] : 3,
          group_id: group?.id,
          custom_attributes: [
            {
              attribute_code: 'marketing_segments',
              value: selectedSegmentsIds
            },
            {
              attribute_code: 'phone_number',
              value: customerRow[3].replace(/\D/g, '')
            }
          ],
        },
        isSendEmailOnCreation: isEnableSendEmail,
      },
      storeViewCode
    };

    if (isCustomer3) {
      task.body.customer.custom_attributes.push({
        attribute_code: 'practice_name',
        value: customerRow[6].trim()
      });
    }

    return task;
  });

  return tasks;
};
